var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect, _path38, _path39, _path40, _g, _rect2, _path41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPermission = function SvgPermission(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 314 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.138 150.246c37.504-5.755 61.691-10.58 88.321-7.905 0 0 37.448 8.188 53.568 5.907 47.14-6.692 55.849-49.032 34.581-83.344-22.023-35.533-69.179-31.285-69.179-31.285-56.127 2.241-91.948-11.008-110.368-20.783-14.764-7.816-33.673-7.598-46.683 1.206-2.92 1.888-5.305 4.274-7.004 7.007-21.146 36.249-5.739 75.65-1.285 99.165 1.641 8.716 20.535 35.786 58.049 30.032Z",
    stroke: "#fff",
    strokeOpacity: 0.4,
    strokeWidth: 0.538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.093 158.016c37.536-10.069 61.619-17.696 89.031-17.962 0 0 39.044 4.132 55.2 0 47.24-12.105 51.355-56.188 25.85-88.732-26.41-33.704-73.941-24.086-73.941-24.086-56.891 8.583-94.847-.885-114.698-8.769-15.908-6.3-35.134-3.955-47.391 6.468-2.761 2.25-4.922 4.947-6.344 7.92-17.46 39.278 2.65 77.663 9.823 101.102 2.65 8.69 24.923 34.129 62.47 24.059Z",
    stroke: "#fff",
    strokeWidth: 0.538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.196 135.094c24.6-4.046 41.263-27.269 37.217-51.87-4.046-24.6-27.269-41.263-51.87-37.217-24.6 4.046-41.263 27.27-37.217 51.87 4.046 24.6 27.27 41.263 51.87 37.217Z",
    fill: "#75C171",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M59.196 135.094c24.6-4.046 41.263-27.269 37.217-51.87-4.046-24.6-27.269-41.263-51.87-37.217-24.6 4.046-41.263 27.27-37.217 51.87 4.046 24.6 27.27 41.263 51.87 37.217Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.808 113.446c-.775 3.09-4.306 2.659-3.23 6.46a45.121 45.121 0 0 0 59.655 8.02c3.23-3.822 5.167-7.837 5.254-11.067.29-9.862-10.131-17.226-10.691-21.974-.56-4.747 3.94-15.481 3.94-15.481s7.881-1.13 10.702-8.16c2.82-7.03-7.903-22.846-17.484-27.637-9.582-4.79-25.623-.56-33.504 10.981-7.88 11.541 1.69 21.683-3.38 27.034-5.071 5.35-18.303 5.63-19.713 16.332-1.41 10.701 9.29 12.112 8.451 15.492Z",
    fill: "#2E2E2E",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.986 54.34s2.853 6.988-8.258 11.111c-11.11 4.124-19.68 1.906-22.544 9.205-2.863 7.3-.635 12.392-.312 16.15.323 3.757-8.613 3.165-13.996 7.934-5.383 4.769 5.383 10.475 8.258 13.651 2.874 3.176 2.218 7.935-2.864 9.528M35.331 68.95s4.123-10.163 10.475-11.756c6.352-1.594 13.34 3.176 18.098-1.27 4.759-4.447 3.811-7.612.312-10.153M73.744 58.464s11.121 7.31 7.31 13.027c-3.81 5.717-5.081-1.27-5.081-1.27",
    stroke: "#fff",
    strokeWidth: 0.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.386 128.465a45.106 45.106 0 0 0 55.219-4.867 101.045 101.045 0 0 0-10.551-8.462c-7.041-4.79-12.672-6.459-16.612-6.201 0 0-3.1 1.411-9.011 7.041-3.854 3.671-13.113 9.13-19.045 12.489Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.853 116.676a19.384 19.384 0 0 0-.797-5.534 20.462 20.462 0 0 0-9.614-2.153s-2.465 1.077-7.17 5.383c-.1.796-.15 1.598-.15 2.401 0 7.396 3.961 13.382 8.86 13.382 4.898 0 8.87-6.083 8.87-13.479Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.181 94.573s0 7.892-.84 15.213c-.839 7.321.28 15.201 5.631 15.761 5.351.56 4.5-12.101 3.94-17.172a46.079 46.079 0 0 1 0-9.57l-8.73-4.232Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "permission_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 94,
    width: 11,
    height: 32
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.181 94.573s0 7.892-.84 15.213c-.839 7.321.28 15.201 5.631 15.761 5.351.56 4.5-12.101 3.94-17.172a46.079 46.079 0 0 1 0-9.57l-8.73-4.232Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#permission_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.18 111.487 9.507-9.216v-.829l-1.938-3.607-6.6-3.23s0 7.892-.84 15.213c-.032.527-.086 1.098-.129 1.669Z",
    fill: "#75C171",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M53.181 94.573s0 7.892-.84 15.213c-.839 7.321.28 15.201 5.631 15.761 5.351.56 4.5-12.101 3.94-17.172a46.079 46.079 0 0 1 0-9.57l-8.73-4.232Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.334 59.38s.56 3.66-9.011 8.17c-9.571 4.511-14.362 8.161-15.202 12.382-.84 4.22-1.13 5.92-1.13 5.92s-1.97-3.95-5.63-1.98c-3.661 1.97-.28 9.582 3.1 9.862 3.38.28 4.22-.851 4.22-.851s10.981 10.981 17.452 10.981c6.47 0 9.01-6.19 10.421-17.225 1.367-10.594-4.22-27.26-4.22-27.26Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "permission_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 59,
    width: 38,
    height: 45
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.334 59.38s.56 3.66-9.011 8.17c-9.571 4.511-14.362 8.161-15.202 12.382-.84 4.22-1.13 5.92-1.13 5.92s-1.97-3.95-5.63-1.98c-3.661 1.97-.28 9.582 3.1 9.862 3.38.28 4.22-.851 4.22-.851s10.981 10.981 17.452 10.981c6.47 0 9.01-6.19 10.421-17.225 1.367-10.594-4.22-27.26-4.22-27.26Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#permission_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.2 81.966a20.455 20.455 0 0 1 3.66-9.85c-4.015 2.626-6.2 5.102-6.739 7.816-.85 4.23-1.13 5.92-1.13 5.92s-1.97-3.95-5.63-1.98c-3.661 1.97-.28 9.582 3.1 9.862 3.38.28 4.22-.851 4.22-.851s10.981 10.981 17.452 10.981a28.242 28.242 0 0 1-5.383-3.488c-3.833-2.799-9.862-11.412-9.55-18.41Z",
    fill: "#75C171",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.334 59.38s.56 3.66-9.011 8.17c-9.571 4.511-14.362 8.161-15.202 12.382-.84 4.22-1.13 5.92-1.13 5.92s-1.97-3.95-5.63-1.98c-3.661 1.97-.28 9.582 3.1 9.862 3.38.28 4.22-.851 4.22-.851s10.981 10.981 17.452 10.981c6.47 0 9.01-6.19 10.421-17.225 1.367-10.594-4.22-27.26-4.22-27.26Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.385 76.465a6.632 6.632 0 0 0 .366 5.383c1.475 2.767 2.218 3.682 1.67 4.425a2.282 2.282 0 0 1-3.145.743M69.276 93.636s-5.383 2.035-7.202-1.851",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.926 80.62c0 1.174-.334 2.154-.743 2.154-.41 0-.732-.948-.732-2.153 0-1.206.323-2.154.732-2.154s.743.98.743 2.154ZM72.969 80.34c.41 0 .743-.949.743-2.12 0-1.172-.333-2.121-.743-2.121s-.743.95-.743 2.12c0 1.172.333 2.122.743 2.122Z",
    fill: "#2E2E2E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.575 74.44s1.077-2.96 5.534-2.4M70.568 71.48s1.292-3.133 4.06-.549",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M267.998 137.921c24.931 0 45.142-20.211 45.142-45.142 0-24.931-20.211-45.142-45.142-45.142-24.931 0-45.142 20.21-45.142 45.142 0 24.931 20.211 45.142 45.142 45.142Z",
    fill: "#9747FF",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M267.998 137.921c24.931 0 45.142-20.211 45.142-45.142 0-24.931-20.211-45.142-45.142-45.142-24.931 0-45.142 20.21-45.142 45.142 0 24.931 20.211 45.142 45.142 45.142Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239.759 127.951a45.095 45.095 0 0 0 61.162-4.242c-5.082-6.545-15.492-17.763-27.077-17.763-12.854 0-28.12 15.341-34.085 22.005Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.003 102.608s-7.655.872-8.312 6.783c-.657 5.91 3.93 15.75 4.371 16.838.442 1.087 10.282-8.742 13.996-8.742 3.714 0 13.339 5.243 13.339 5.243s-3.057-12.252-8.527-16.849c-5.469-4.597-13.349-5.028-14.867-3.273Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.937 80.904s-3.284-3.284-5.028-.657c-1.744 2.627-.226 5.684 2.153 7.655 2.38 1.97 6.126 2.153 6.126.656 0-1.496-3.251-7.654-3.251-7.654Z",
    fill: "#9747FF",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M252.937 80.904s-3.284-3.284-5.028-.657c-1.744 2.627-.226 5.684 2.153 7.655 2.38 1.97 6.126 2.153 6.126.656 0-1.496-3.251-7.654-3.251-7.654Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M281.165 73.292s1.529-3.94 3.714.215c2.186 4.156-1.97 7.87-1.97 7.87l-1.744-8.085Z",
    fill: "#fff",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M256.221 88.602s4.371 15.75 5.469 21.219c1.098 5.469 6.126 13.35 9.84 10.766 3.714-2.583 3.51-7.439 1.313-11.595a51.185 51.185 0 0 1-3.499-8.968l-13.123-11.422Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "permission_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 256,
    y: 88,
    width: 19,
    height: 34
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M256.221 88.602s4.371 15.75 5.469 21.219c1.098 5.469 6.126 13.35 9.84 10.766 3.714-2.583 3.51-7.439 1.313-11.595a51.185 51.185 0 0 1-3.499-8.968l-13.123-11.422Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#permission_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.843 108.949a51.19 51.19 0 0 1-3.499-8.968l-13.123-11.38s3.585 12.92 5.07 19.379a19.303 19.303 0 0 0 6.363 3.284 8.057 8.057 0 0 0 5.943-.678 14.082 14.082 0 0 0-.754-1.637Z",
    fill: "#9747FF",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M256.221 88.602s4.371 15.75 5.469 21.219c1.098 5.469 6.126 13.35 9.84 10.766 3.714-2.583 3.51-7.439 1.313-11.595a51.185 51.185 0 0 1-3.499-8.968l-13.123-11.422Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M248.372 72.194s10.281 24.762 14.663 30.414c4.382 5.652 16.149 6.126 21.22-2.153 5.071-8.28-.657-19.465-1.529-24.504-.872-5.038-3.23-13.339-1.755-14.867 1.475-1.53 7.655-2.627 5.254-6.568-2.401-3.94-5.91-1.97-6.341-4.812-.431-2.842 1.744-9.851-6.352-10.938-8.096-1.088-22.318 8.526-27.992 15.966-5.673 7.439-7.482 14.178 2.832 17.462Z",
    fill: "#2E2E2E",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M251.602 64.755s-6.74-.506-3.359-6.987c3.38-6.482 25.935-15.213 26.215-10.422.28 4.79-4.791 6.201-4.791 6.201",
    stroke: "#fff",
    strokeWidth: 0.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M260.667 58.618s-5.071-1.13-3.381-4.79c1.691-3.661 14.093-5.384 11.843-3.101a19.717 19.717 0 0 1-4.511 3.38M276.999 87.073s-3.714 5.9-9.625 3.057",
    stroke: "#fff",
    strokeWidth: 0.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M282.694 75.908c-.818-4.704-2.982-12.294-2.002-14.501-.657-1.583-2.918-5.276-9.593-5.62-8.537-.442-17.721 4.37-19.476 8.968-1.754 4.597 2.412 2.153 3.941 5.469 1.528 3.316-2.412 7.224-1.529 9.625.883 2.4 5.028 11.842 5.028 11.842.656-2.627 10.507-7.008 10.507-7.008 1.425.376 2.9.525 4.371.441 1.97-.215.872-1.97.872-1.97l10.088.603c-.861-3.176-1.884-5.943-2.207-7.849Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "permission_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 251,
    y: 55,
    width: 34,
    height: 37
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M282.694 75.908c-.818-4.704-2.982-12.294-2.002-14.501-.657-1.583-2.918-5.276-9.593-5.62-8.537-.442-17.721 4.37-19.476 8.968-1.754 4.597 2.412 2.153 3.941 5.469 1.528 3.316-2.412 7.224-1.529 9.625.883 2.4 5.028 11.842 5.028 11.842.656-2.627 10.507-7.008 10.507-7.008 1.425.376 2.9.525 4.371.441 1.97-.215.872-1.97.872-1.97l10.088.603c-.861-3.176-1.884-5.943-2.207-7.849Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#permission_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.396 66.51c-.409-4.307-3.23-5.157-5.103-5.233a9.266 9.266 0 0 0-2.691 3.478c-1.745 4.597 2.411 2.153 3.94 5.469 1.529 3.316-2.412 7.224-1.529 9.625.883 2.4 5.028 11.842 5.028 11.842.215-.84 1.356-1.862 2.821-2.853-2.154-3.068-4.781-6.804-6.266-8.968-2.799-4.145 4.435-6.685 3.8-13.36Z",
    fill: "#9747FF",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M282.694 75.908c-.818-4.704-2.982-12.294-2.002-14.501-.657-1.583-2.918-5.276-9.593-5.62-8.537-.442-17.721 4.37-19.476 8.968-1.754 4.597 2.412 2.153 3.941 5.469 1.528 3.316-2.412 7.224-1.529 9.625.883 2.4 5.028 11.842 5.028 11.842.656-2.627 10.507-7.008 10.507-7.008 1.425.376 2.9.525 4.371.441 1.97-.215.872-1.97.872-1.97l10.088.603c-.861-3.176-1.884-5.943-2.207-7.849Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M264.155 74.853c.28 1.217 0 2.326-.549 2.455-.549.13-1.281-.754-1.55-1.98-.27-1.228 0-2.326.549-2.456.549-.129 1.281.754 1.55 1.981ZM277.182 72.173c.28 1.227 0 2.325-.549 2.454-.549.13-1.281-.753-1.561-1.98-.28-1.228 0-2.326.56-2.455.559-.13 1.27.753 1.55 1.98Z",
    fill: "#2E2E2E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M259.062 69.126s.873-4.813 5.911-2.843M278.517 64.098c-3.725-2.411-5.039 1.077-5.039 1.077s-2.358 2.584-1.399 7.353",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m259.72 82.034 6.341-2.616M275.04 77.448l5.243-.441",
    stroke: "#2E2E2E",
    strokeWidth: 0.538,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M153.846 179.199a37.96 37.96 0 1 1-.001-75.923 37.96 37.96 0 0 1 .001 75.923Z",
    fill: "#2E2E2E",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M164.002 136.393a1.436 1.436 0 0 1 1.436 1.436 11.485 11.485 0 0 1-10.047 11.395l-.002 2.96h4.307a1.435 1.435 0 1 1 0 2.87h-11.484a1.435 1.435 0 1 1 0-2.87h4.306v-2.96a11.485 11.485 0 0 1-10.048-11.395 1.436 1.436 0 1 1 2.871 0 8.614 8.614 0 0 0 17.226 0 1.435 1.435 0 0 1 1.435-1.436Zm-10.048-11.483a5.744 5.744 0 0 1 5.742 5.742v7.177a5.741 5.741 0 0 1-11.484 0v-7.177a5.743 5.743 0 0 1 5.742-5.742Z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M168.725 110.124c3.559 1.7 6.8 3.997 9.581 6.794M132.476 114.172a34.448 34.448 0 0 1 33.869-5.081M149.647 175.463a34.454 34.454 0 0 1-24.632-15.331 34.454 34.454 0 0 1 1.195-39.5M162.394 174.656a33.92 33.92 0 0 1-6.858 1.076M178.307 116.918a35.62 35.62 0 0 1 4.392 5.383 34.452 34.452 0 0 1-9.958 47.747 34.943 34.943 0 0 1-7.999 3.876",
    stroke: "#fff",
    strokeWidth: 0.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 179.792,
    y: 129.115,
    width: 25.838,
    height: 25.838,
    rx: 12.919,
    fill: "#4DA648"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m197.879 138.805-6.46 6.46-3.23-3.23",
    stroke: "#fff",
    strokeWidth: 1.615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M153.846 76.922a37.96 37.96 0 1 1 0-75.922 37.962 37.962 0 1 1 0 75.922Z",
    fill: "#2E2E2E",
    stroke: "#2E2E2E",
    strokeWidth: 1.077,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.964 9.462a34.207 34.207 0 0 1 10.927-4.306M119.503 42.008a35.715 35.715 0 0 1-.129-3.047 34.443 34.443 0 0 1 14.437-28.067M180.158 61.247a34.38 34.38 0 0 1-26.312 12.198 34.503 34.503 0 0 1-32.395-22.61M186.489 50.114a34.92 34.92 0 0 1-2.896 6.31M146.892 5.177a34.44 34.44 0 0 1 6.954-.7 34.452 34.452 0 0 1 34.452 34.452 34.528 34.528 0 0 1-1.142 8.817",
    stroke: "#fff",
    strokeWidth: 0.807,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#permission_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.639 31.232-6.029 3.398v-4.69a1.914 1.914 0 0 0-1.914-1.914H142.47a3.827 3.827 0 0 0-3.827 3.828v15.312a3.827 3.827 0 0 0 3.827 3.828h17.226a1.91 1.91 0 0 0 1.914-1.914v-4.708l6.029 3.397a1.053 1.053 0 0 0 1.627-.823v-14.9a1.053 1.053 0 0 0-1.627-.813Z",
    fill: "#fff"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.354,
    y: 10.69,
    width: 25.838,
    height: 25.838,
    rx: 12.919,
    fill: "#4DA648"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m121.441 20.379-6.459 6.46-3.23-3.23",
    stroke: "#fff",
    strokeWidth: 1.615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "permission_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136.729 22.284)",
    d: "M0 0h34.451v34.451H0z"
  })))));
};
export default SvgPermission;